import type { User } from '@/types';

/**
 * Get user initials from user name or username
 * @param user - User object with name and/or username
 * @returns Two character initials string
 */
export function getUserInitials(user: User | null): string {
  if (!user) {
    return 'U';
  }

  if (user.name) {
    return user.name
      .split(' ')
      .map(part => part.charAt(0).toUpperCase())
      .join('')
      .slice(0, 2);
  }

  if (user.username) {
    return user.username
      .split('.')
      .map(part => part.charAt(0).toUpperCase())
      .join('')
      .slice(0, 2);
  }

  return 'U';
}

/**
 * Get the first name from a full name
 * @param user - User object with name
 * @returns First name or empty string if not available
 */
export function getUserFirstName(user: User | null): string {
  if (!user || !user.name) {
    return '';
  }

  const firstName = user.name.split(' ')[0]?.trim();

  return firstName ?? '';
}
